import React from 'react';

const Cta = () => {
    const scrollTo = (id) => {
        const el = document.querySelector(id);
        if (el) {
            const top = el.getBoundingClientRect().top + window.scrollY - 80;
            window.scrollTo({ top, behavior: 'smooth' });
        }
    };

    return (
        <section className="cta">
            <div className="cta__bg" />
            <div className="cta__content">
                <p className="section-eyebrow cta__eyebrow">Sizin İçin Buradayız</p>
                <h2 className="cta__title">
                    Hayalinizdeki Mekanı<br />Birlikte Yaratalım
                </h2>
                <p className="cta__text">
                    Kişiselleştirilmiş mekanlar için Arth Yapı ile iletişime geçin. Projeleriniz için özel çözümler sunuyoruz.
                </p>
                <button className="btn btn--primary" onClick={() => scrollTo('#iletisim')}>
                    Bize Ulaşın
                </button>
            </div>
        </section>
    );
};

export default Cta;
